import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/i18n"; // bootstraps i18next before any component renders
import App from "@/App";
import { installAuthInterceptor } from "@/lib/auth";

// Install global Bearer token interceptor as soon as the app boots.
// Necessary because cross-domain cookies (samesite=none) are increasingly unreliable
// due to Chrome CHIPS / Firefox / Safari ITP cookie partitioning policies.
installAuthInterceptor();

// Safeguard against DOM mutations by browser translators (Chrome/Edge auto-translate)
// and extensions. Without this, React crashes with NotFoundError on removeChild/insertBefore
// when external scripts wrap text nodes (e.g. <font> tags injected by Google Translate).
if (typeof Node === "function" && Node.prototype) {
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child) {
    if (child.parentNode !== this) {
      if (console) console.warn("Ignored removeChild on detached node (translator/extension DOM mutation)");
      return child;
    }
    return originalRemoveChild.apply(this, arguments);
  };
  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      if (console) console.warn("Ignored insertBefore on detached node (translator/extension DOM mutation)");
      return newNode;
    }
    return originalInsertBefore.apply(this, arguments);
  };
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
